import { CustomAuthConfiguration, LogLevel } from "@azure/msal-browser/custom-auth";

const entraTenantSubdomain =
  import.meta.env.VITE_ENTRA_TENANT_SUBDOMAIN || "examfycustomers";
const entraTenantId = import.meta.env.VITE_ENTRA_TENANT_ID || "";
const baseUrl =
  import.meta.env.VITE_API_BASE_URL || window.location.origin;

function buildCustomAuthConfig(): CustomAuthConfiguration {
  return {
    customAuth: {
      challengeTypes: ["password", "oob", "redirect"],
      authApiProxyUrl: `${baseUrl}/api/auth/entra`,
    },
    auth: {
      clientId: import.meta.env.VITE_ENTRA_CLIENT_ID || "",
      authority: `https://${entraTenantSubdomain}.ciamlogin.com/${entraTenantId}`,
      redirectUri: "/",
      postLogoutRedirectUri: "",
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (
          level: LogLevel,
          message: string,
          containsPii: boolean,
        ) => {
          if (containsPii) return;
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
          }
        },
      },
    },
  };
}

export const customAuthConfig = buildCustomAuthConfig();
